import { ValidationResult } from './validation-result';
import { DwUtils } from "../components/utils/dw-utils";
import { NewRequest } from "./newrequest";
import {ServiceRequest} from "./service.request";

export interface Case {
	id: number;
	flatRequestId: number | null;
	caseNumber: string;
	dataShareAgreement: string;
	firstName: string;
	middleName: string;
	lastName: string;
	address1: string;
	address2: string;
	city: string;
	state: string;
	zipCode: string;
	county: string;
	phoneNumber: string;
	email: string;
	currentNeed:string;
	createSource: string;
	dateCreated: Date;
	alias: string;
	familyConnection: string;
	dateOfBirth: Date;
	caseStatus: string;
	dateOpened: Date;
	dateClosed: Date;
	advocateEmail: string;
	advocatePhoneNumber: string;
	
	clericalOpen: number;
	newDateOpened: string;
	newDateClosed: string;
	suppressEmailFlag: number;
}

export class Case {
	constructor() {
		this.id = 0;
		this.flatRequestId = null;
		this.caseNumber = '';
		this.dataShareAgreement = '';
		this.firstName = '';
		this.middleName = '';
		this.lastName = '';
		this.address1 = '';
		this.address2 = '';
		this.city = '';
		this.state = '';
		this.zipCode = '';
		this.county = '';
		this.phoneNumber = '';
		this.currentNeed = '';
		this.email = '';
		this.createSource = '';
		this.dateCreated = new Date();
		this.alias = '';
		this.caseStatus = '';
		this.familyConnection = '';
		this.dateOfBirth = null;
		this.advocateEmail = '';
		this.clericalOpen = 0;

	}
	public clone(): Case {
		const clonedCase = new Case();
		clonedCase.id = this.id;
		clonedCase.flatRequestId = this.flatRequestId;
		clonedCase.caseNumber = this.caseNumber;
		clonedCase.dataShareAgreement = this.dataShareAgreement;
		clonedCase.firstName = this.firstName;
		clonedCase.middleName = this.middleName;
		clonedCase.lastName = this.lastName;
		clonedCase.address1 = this.address1;
		clonedCase.address2 = this.address2;
		clonedCase.city = this.city;
		clonedCase.state = this.state;
		clonedCase.zipCode = this.zipCode;
		clonedCase.county = this.county;
		clonedCase.phoneNumber = this.phoneNumber;
		clonedCase.email = this.email;
		clonedCase.createSource = this.createSource;
		clonedCase.dateOfBirth = this.dateOfBirth;
		clonedCase.currentNeed = this.currentNeed;
		clonedCase.caseStatus = this.caseStatus;
		clonedCase.dateOpened = this.dateOpened;
		clonedCase.dateClosed = this.dateClosed;
		// Copy any additional properties here
		clonedCase.advocateEmail = this.advocateEmail;
		clonedCase.advocatePhoneNumber = this.advocatePhoneNumber;
		clonedCase.familyConnection = this.familyConnection;
		clonedCase.clericalOpen = this.clericalOpen;

		return clonedCase;
	}
	public setCaseForNewRequest(req: NewRequest): void {
		this.id = 0;
		this.flatRequestId = 0;
		this.caseNumber = req.caseNumber;
		this.dataShareAgreement = 'Accepted';
		this.firstName = (req.firstName || '').trim();
		this.middleName = (req.middleName || '').trim();
		this.lastName = (req.lastName || '').trim();
		this.address1 = req.address1;
		this.address2 = req.address2;
		this.city = req.city;
		this.state = req.state;
		this.zipCode = req.zipCode;
		this.county = req.county;
		this.phoneNumber = req.phoneNumber;
		this.email = req.emailAddress;
		this.createSource = 'Manual Add';
		this.dateCreated = new Date();
		this.alias = '';
		this.familyConnection = '';
		this.currentNeed = req.currentNeed;
		this.dateOfBirth = new Date(req.dob + 'T09:00');		/** irregular naming ***/
		this.advocateEmail = '';
		this.clericalOpen = 0;
	}
	public returnCaseName():string {

		let caseName = this.firstName;

		if(this.middleName.length > 0) {
			caseName += ' ' + this.middleName;
		}
		caseName += ' ' + this.lastName;

		return caseName;

	}
	public validateRecord(): ValidationResult {

		const vr: ValidationResult = new ValidationResult();

		// Trim names to remove leading/trailing spaces
		this.firstName = (this.firstName || '').trim();
		this.middleName = (this.middleName || '').trim();
		this.lastName = (this.lastName || '').trim();

		if (this.caseNumber.length === 0) {
			vr.focus_field = 'caseNumber';
			vr.error = 'Error: A case number is required';
			return vr;
		}

		if (this.firstName.length === 0) {
			vr.focus_field = 'firstName';
			vr.error = 'Error: First name is required';
			return vr;
		}

		if (this.lastName.length === 0) {
			vr.focus_field = 'lastName';
			vr.error = 'Error: Last name is required';
			return vr;
		}

		/** if an email was specified ***/
		if (this.email !== null && this.email.length > 0) {
			if (DwUtils.validEmailAddress(this.email) === false) {
				vr.focus_field = 'emailAddress';
				vr.error = 'Error: the specified email is not valid (must be user@domain.com or .net etc.)';
				return vr;
			}
		}

		if (this.dateOfBirth != null) {
			const resp = DwUtils.chkDateOfBirth(this.dateOfBirth.toString());
			if (resp.length > 0) {
				vr.focus_field = 'dob';
				vr.error = 'Error: ' + resp;
				return vr;
			}
		}

		return vr;
	}
}
